(function(){
  var sd=document.getElementById("sd"); if(!sd) return;
  var q=sd.querySelector("[data-sd-q]"), list=sd.querySelector("[data-sd-list]"), head=sd.querySelector("[data-sd-head]"),
      all=sd.querySelector("[data-sd-all]"), form=sd.querySelector("form"), base=form.getAttribute("action"),
      api=sd.getAttribute("data-suggest")+".json", root=document.documentElement, last=null, timer=0, ctrl=null;
  var lei=new Intl.NumberFormat("ro-RO",{minimumFractionDigits:2,maximumFractionDigits:2});
  function open(val){
    root.classList.add("sd-open"); root.style.overflow="hidden";
    if(val!=null && val!==q.value){ q.value=val; search(); }
    /* focus imediat, în același click: pe iPhone tastatura se deschide doar așa, iar literele tastate nu se pierd */
    q.focus(); var n=q.value.length; try{ q.setSelectionRange(n,n); }catch(e){}
  }
  function close(){ root.classList.remove("sd-open"); root.style.overflow=""; }
  function href(term){ return base+"?q="+encodeURIComponent(term)+"&type=product"; }
  function render(term,items){
    list.textContent="";
    head.hidden=!items.length;
    if(!items.length){ var m=document.createElement("p"); m.className="sd-msg"; m.textContent="Niciun produs găsit pentru „"+term+"”."; list.appendChild(m); all.hidden=true; return; }
    items.forEach(function(p){
      var a=document.createElement("a"); a.className="sd-r"; a.href=p.url;
      var img=document.createElement("img"); img.alt=""; img.width=56; img.height=56; img.loading="lazy";
      if(p.image) img.src=p.image+(p.image.indexOf("?")<0?"?":"&")+"width=120";
      var d=document.createElement("div"), b=document.createElement("b"), s=document.createElement("span");
      b.textContent=p.title;
      s.textContent=(p.price_min!==p.price_max?"de la ":"")+lei.format(parseFloat(p.price))+" lei";
      if(!p.available){ var o=document.createElement("span"); o.className="out"; o.textContent=" · stoc epuizat"; s.appendChild(o); }
      d.appendChild(b); d.appendChild(s); a.appendChild(img); a.appendChild(d); list.appendChild(a);
    });
    all.hidden=false; all.href=href(term); all.textContent="Vezi toate rezultatele pentru „"+term+"”";
  }
  /* căutarea Shopify adaugă și produse „asemănătoare” (ex. bufnițe la „funda”); păstrăm doar produsele care conțin
     toate cuvintele căutate (fără diacritice, ultima literă liberă: funda/funde/fundă) în nume, tip sau etichete */
  function norm(s){ return (s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,""); }
  function stems(term){ return norm(term).split(/[^a-z0-9]+/).filter(function(w){ return w.length>=3; }).map(function(w){ return w.length>4?w.slice(0,-1):w; }); }
  function relevant(term,items){
    var st=stems(term); if(!st.length) return items.slice(0,5);
    var hit=items.filter(function(p){ var h=norm(p.title+" "+(p.type||"")+" "+(p.tags||[]).join(" ")); return st.every(function(s){ return h.indexOf(s)>=0; }); });
    return (hit.length?hit:items).slice(0,5);
  }
  function search(){
    var term=q.value.trim();
    if(term===last) return; last=term;
    if(ctrl) ctrl.abort();
    if(!term){ list.textContent=""; head.hidden=true; all.hidden=true; return; }
    ctrl=window.AbortController?new AbortController():null;
    fetch(api+"?q="+encodeURIComponent(term)+"&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last",ctrl?{signal:ctrl.signal}:{})
      .then(function(r){ return r.json(); })
      .then(function(j){ if(term===q.value.trim()) render(term,relevant(term,((j.resources||{}).results||{}).products||[])); })
      .catch(function(){});
  }
  q.addEventListener("input",function(){ clearTimeout(timer); timer=setTimeout(search,180); });
  form.addEventListener("submit",function(e){ if(!q.value.trim()) e.preventDefault(); });
  document.querySelectorAll("[data-sd-close]").forEach(function(b){ b.addEventListener("click",close); });
  document.addEventListener("keydown",function(e){ if(e.key==="Escape" && root.classList.contains("sd-open")) close(); });
  /* lupa de pe mobil și câmpul din antet (desktop) deschid sertarul */
  document.querySelectorAll("[data-sd-open]").forEach(function(b){ b.addEventListener("click",function(e){ e.preventDefault(); open(); }); });
  var hq=document.getElementById("amcq");
  if(hq){
    hq.addEventListener("focus",function(){ open(hq.value); });
    hq.form && hq.form.addEventListener("submit",function(e){ e.preventDefault(); open(hq.value); });
  }
})();
